export const SIGN_IN_PATH = '/sign-in'
export const HOME_PATH = '/home'
export const CREATE_USER_PATH = '/create-user'
export const EDIT_USER_PATH = '/edit-user'

export const ROUTES_BAR = {
  [HOME_PATH]: [{ title: 'pageTitles.home', path: HOME_PATH }],
  [CREATE_USER_PATH]: [
    { title: 'pageTitles.home', path: HOME_PATH },
    { title: 'pageTitles.create-user', path: CREATE_USER_PATH }
  ],
  [EDIT_USER_PATH]: [
    { title: 'pageTitles.home', path: HOME_PATH },
    { title: 'pageTitles.edit-user', path: EDIT_USER_PATH }
  ]
}
